"use client";

import { useState, useRef, useEffect } from "react";
import { Dialog, DialogPanel } from "@headlessui/react";
import LogoBootverzekering from "../assets/LogoBootverzekering.svg";
import {
  Bars3Icon,
  XMarkIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/outline";

const navigation = [
  { name: "Verzekeringsmodule", href: "/verzekeringsmodule" },
  { name: "Algemeen", href: "#" },
];

export default function Example() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const dropdownRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    function handleScroll() {
      setDropdownOpen(false);
    }

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className="relative z-20">
      <nav
        aria-label="Global"
        className="mx-auto flex max-w-7xl items-center justify-between p-2 lg:px-8"
      >
        {/* Left: Logo and Title (Single Link) */}
        {!mobileMenuOpen && (
          <div className="flex items-center gap-x-4">
            <a href="/" className="flex items-center gap-x-1 -m-1.5 p-1.5">
              <img
                alt="Logo Bootverzekering"
                src={LogoBootverzekering}
                className="h-20 sm:h-32 lg:h-40 w-auto"
              />
              <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1a2a6c]">
                boot-verzekering.be
              </h1>
            </a>
          </div>
        )}

        {/* Right: Navigation Links and Contact Button */}
        {!mobileMenuOpen && (
          <div className="hidden lg:flex items-center gap-x-6">
            <a
              href="/verzekeringsmodule"
              className="text-base font-semibold text-[#1a2a6c] hover:text-[#ff6f61]"
            >
              Verzekeringsmodule
            </a>
            <div className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="text-base font-semibold text-[#1a2a6c] hover:text-[#ff6f61] flex items-center gap-1"
              >
                Algemeen
                <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
              </button>
              {dropdownOpen && (
                <div
                  ref={dropdownRef}
                  className="absolute top-full mt-6 w-40 bg-[#1a2a6c] text-[#ff6f61] shadow-lg rounded-md"
                >
                  <a
                    href="/informatie"
                    className="block px-4 py-2 text-sm hover:bg-[#142057] rounded-md"
                  >
                    Informatie
                  </a>
                  <a
                    href="/faq"
                    className="block px-4 py-2 text-sm hover:bg-[#142057] rounded-md"
                  >
                    FAQ
                  </a>
                </div>
              )}
            </div>

            <a
              href="/contact"
              className="rounded-md bg-[#1a2a6c] px-3.5 py-2.5 text-sm font-semibold text-[#ff6f61] shadow-sm hover:bg-[#142057]"
            >
              Contact
            </a>
          </div>
        )}

        {/* Mobile: Hamburger Menu */}
        {!mobileMenuOpen && (
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="ml-2 inline-flex items-center justify-center rounded-md p-2.5 text-[#1a2a6c] lg:hidden"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="h-6 w-6 text-[#1a2a6c]" />
          </button>
        )}
      </nav>

      {/* Mobile Menu Dialog */}
      <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div className="fixed inset-0 z-10" />
        <DialogPanel className="fixed inset-y-0 left-0 z-10 w-full overflow-y-auto bg-[#efebe2] px-6 py-6">
          {/* Top Section */}
          <div className="flex items-center justify-between">
            {/* Close Button */}
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-[#1a2a6c]"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon
                aria-hidden="true"
                className="h-6 w-6 text-[#1a2a6c]"
              />
            </button>

            {/* Logo in the Middle */}
            <div className="flex justify-center flex-grow">
              <img
                src={LogoBootverzekering}
                alt="Logo Bootverzekering"
                className="h-16 w-auto"
              />
            </div>

            {/* Contact Button */}
            <a
              href="/contact"
              className="rounded-md bg-[#1a2a6c] px-4 py-2 text-sm font-semibold text-[#ff6f61] shadow-sm hover:bg-[#142057]"
            >
              Contact
            </a>
          </div>

          {/* Navigation Links */}
          <div className="mt-6 space-y-2">
            {/* {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-[#1a2a6c] hover:bg-[#ff6f61] hover:text-white"
              >
                {item.name}
              </a>
            ))} */}
            <a
              href="/verzekeringsmodule"
              className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-[#1a2a6c] hover:bg-[#ff6f61] hover:text-white"
            >
              Verzekeringsmodule
            </a>
            <a
              href="/informatie"
              className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-[#1a2a6c] hover:bg-[#ff6f61] hover:text-white"
            >
              Informatie
            </a>
            <a
              href="/faq"
              className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-[#1a2a6c] hover:bg-[#ff6f61] hover:text-white"
            >
              FAQ
            </a>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
}
